import script from "./partnerships.vue?vue&type=script&setup=true&lang=js"
export * from "./partnerships.vue?vue&type=script&setup=true&lang=js"

import "./partnerships.vue?vue&type=style&index=0&id=becf919a&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-becf919a"]])

export default __exports__